<template>
  <el-radio-group
    :disabled="disabled"
    v-bind="$attrs"
    v-model="selectValue"
    @change="handleChange"
  >
    <slot />
  </el-radio-group>
</template>

<script>
export default {
  name: 'RtRadioGroup',
  props: {
    value: String | Number | Boolean,
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectValue: this.value
    };
  },
  watch: {
    value(newVal, oldVal) {
      this.selectValue = newVal;
    }
  },
  methods: {
    handleChange(val) {
      this.$emit('input', val);
      this.$emit('change', val);
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtRadioGroup.vue?569ab575